import React from "react";
import "../index.css";

function HeroSection() {
    return (
        <section className="bg-gradient-to-r from-blue-400/70 to-blue-600/70 text-white py-20 px-4">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 max-w-6xl mx-auto">
                {/* Linkes Auto */}
                <img
                    src="/images/autos1.png"
                    alt="Autosilhouette 1"
                    className="max-w-xs w-full hidden md:block"
                />

                {/* Text in der Mitte */}
                <div className="text-center flex-1">
                    <h2 className="text-4xl md:text-5xl font-extrabold mb-6">
                        Ihr Auto in besten Händen
                    </h2>
                    <p className="text-lg md:text-xl mb-8 max-w-2xl mx-auto">
                        Schnell, zuverlässig und professionell – wir kümmern uns um Ihr Fahrzeug.
                    </p>
                    <h2 className="text-4xl md:text-5xl font-extrabold mb-6">
                        Autoservice Groß GmbH
                    </h2>
                    <div className="lg:hidden mt-6">
                        <button
                            onClick={() => {
                                document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
                            }}
                            className="bg-white text-blue-600 font-bold px-8 py-4 rounded-full shadow-lg hover:bg-blue-50 transition active:scale-95 text-lg inline-flex items-center gap-2"
                        >
                            📅 Jetzt Termin anfragen
                        </button>
                    </div>
                </div>

                {/* Rechtes Auto */}
                <img
                    src="/images/autos2.png"
                    alt="Autosilhouette 2"
                    className="max-w-xs w-full hidden md:block"
                />
            </div>
        </section>
    );
}

export default HeroSection;
